import { Provider } from "@redotech/redo-order-common/provider";
import { redoProductDataSchema } from "@redotech/redo-product-common/product";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProduct = {
  name: "getProduct" as const,
  input: z.object({
    productId: z.string(),
    provider: createEnum(Provider),
    includeProductsAsVariants: z.boolean().optional(),
  }),
  output: z.object({ product: redoProductDataSchema.nullable() }),
};
